// Configuração centralizada da API
// Em produção (Vercel), usa a variável de ambiente REACT_APP_API_URL
// Em desenvolvimento, usa localhost:8000

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');

export default API_URL;
